import React, { useState, useEffect } from "react";
import { Routes, Route, Outlet } from "react-router-dom"; 
import Header from "./Component/Header";
import HeroSection from "./Component/HeroSection";
import StatsSection from "./Pages/starbar";
import TopCoursesSection from "./Pages/CourseCard";
import WhyChooseUs from "./Pages/WhyChooseUs";
import Tranning from "./Pages/tranning";
import Footer from "./Pages/Footer";
import TrainingBanner from "./Pages/banner";
import RegistrationModal from "./Component/RegistrationModal";
import CertificateVerification from "./Pages/CertificateVerification";
import AboutUs from "./Pages/AboutUs";
import GuidancePage from "./Pages/GuidancePage";
import ContactBanner from "./Pages/ContactBanner";
import AIChatExpert from "./Pages/AIChatExpert";
import SuccessStoriesPage from "./Pages/SuccessStoriesPage";
import NotesPage from "./Pages/NotesPage";
import VideoGallery from "./Pages/VideoPage";
import InterviewQuestionsPage from "./Pages/InterviewQuestionsPage";
import JavaFullStackRedBlack from "./Pages/Course/web-development/JavaFullStack";
import PythonFullStack from "./Pages/Course/web-development/PythonFullStack";
import MERNFullStack from "./Pages/Course/web-development/MERNFullStack";
import BackendDeveloper from "./Pages/Course/web-development/BackendDeveloper";
import FrontendDeveloper from "./Pages/Course/web-development/FrontendDeveloper";
import ReactJSDeveloper from "./Pages/Course/web-development/ReactJS";
import AngularFullStack from "./Pages/Course/web-development/AngularFullStack";
import WordPressDev from "./Pages/Course/web-development/WordpressDevelopment";
import AndroidDev from "./Pages/Course/app-development/AndroidDev";
import IOSDevelopment from "./Pages/Course/app-development/IOSDev";
import FlutterDev from "./Pages/Course/app-development/FlutterDev";
import ReactNativeDev from "./Pages/Course/app-development/ReactNativeDev";
import CLanguage from "./Pages/Course/programming/CLanguage";
import CppLanguage from "./Pages/Course/programming/CppLanguage";
import CoreJava from "./Pages/Course/programming/CoreJava";
import AdvancedJava from "./Pages/Course/programming/AdvancedJava";
import CorePython from "./Pages/Course/programming/CorePython";
import AdvancePython from "./Pages/Course/programming/AdvancePython";
import DSA from "./Pages/Course/programming/DSA";
import JavaScriptTypeScript from "./Pages/Course/programming/JavaScriptTypeScript";
import SpringBootDev from "./Pages/Course/programming/SpringBootDev";
import ManualTesting from "./Pages/Course/software-testing/ManualTesting";
import AutomationTesting from "./Pages/Course/software-testing/AutomationTesting";
import MobileTesting from "./Pages/Course/software-testing/MobileTesting";
import APITesting from "./Pages/Course/software-testing/APITesting";
import PerformanceTesting from "./Pages/Course/software-testing/PerformanceTesting";
import SQLCourse from "./Pages/Course/database/SQL";
import MySQLCourse from "./Pages/Course/database/MySQL";
import MongoDBCourse from "./Pages/Course/database/MongoDB";
import PostgreSQL from "./Pages/Course/database/PostgreSQL";
import OracleCourse from "./Pages/Course/database/Oracle";
import AWSCourse from "./Pages/Course/clouds & devoops/AWSCourse";
import AzureCourse from "./Pages/Course/clouds & devoops/AzureCourse";
import GCPCourse from "./Pages/Course/clouds & devoops/GCPCourse";
import DockerKubernetes from "./Pages/Course/clouds & devoops/DockerKubernetes";
import LinuxAdmin from "./Pages/Course/clouds & devoops/LinuxAdmin";
import CyberSecurity from "./Pages/Course/clouds & devoops/CyberSecurity";
import { AuthProvider } from "./context/AuthContext";
import OAuthCallback from './Component/OAuthCallback';
import UserProfile from "./Pages/UserProfile";

// Admin Imports
import AdminLogin from "./Admin/pages/AdminLogin";
import AdminDashboard from "./Admin/pages/AdminDashboard";
import AdminLayout from "./Admin/components/AdminLayout"; // New Layout Import
import StudentList from "./Admin/pages/StudentList";
import AddStudent from "./Admin/pages/AddStudent";
import EditStudent from "./Admin/pages/EditStudent";
import QueryList from "./Admin/pages/QueryList";
import SyllabusPage from "./Admin/pages/SyllabusPage";
import LoginPopup from "./Component/LoginPopup";
import AdminNotes from "./Admin/pages/AdminNotes";
import AdminInterview from "./Admin/pages/AdminInterview";
import CertificatePage from "./Admin/pages/AdminCertificatePage";
import WithWeb from "./Pages/WithWeb";
import WithApp from "./Pages/WithApp";
import QuotationRequests from "./Admin/pages/QuotationRequests";
import CreateQuotation from "./Admin/pages/CreateQuotation";
import QuotationHistory from "./Admin/pages/QuotationHistory";
import ContactPage from "./Pages/ContactPage";
import EnquiryPage from "./Pages/EnquiryPage";
import AdminAdEnquiries from "./Admin/pages/AdminAdEnquiries";
import InvoiceHistory from "./Admin/pages/InvoiceHistory";
import CreateInvoice from "./Admin/pages/CreateInvoice";
import AdminAiBlog from "./Admin/pages/AdminAiBlog";
import BlogDetail from "./Pages/BlogDetail";
import BlogList from "./Pages/BlogList";
import ManageBlogs from "./Admin/pages/ManageBlogs";

// Modal constants
const REGISTRATION_TIMEOUT_MS = 5 * 60 * 1000;
const INITIAL_DELAY_MS = 2500;
const LOCAL_STORAGE_KEY = "registrationModalClosedAt";


function App() {
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const handleRegistrationOpen = (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
  ) => {
    e.preventDefault();
    setShowRegistrationModal(true);
  };

  const handleRegistrationClose = () => {
    setShowRegistrationModal(false);
    localStorage.setItem(LOCAL_STORAGE_KEY, String(Date.now()));
  };

  useEffect(() => {
    const checkAndOpenModal = () => {
      const closedAt = localStorage.getItem(LOCAL_STORAGE_KEY);
      const now = Date.now();
      let shouldOpen = true;

      if (closedAt) {
        const closedTimestamp = parseInt(closedAt, 10);
        if (now - closedTimestamp < REGISTRATION_TIMEOUT_MS) {
          shouldOpen = false;
        }
      }

      if (shouldOpen) setShowRegistrationModal(true);
    };

    const timerId = setTimeout(checkAndOpenModal, INITIAL_DELAY_MS);
    return () => clearTimeout(timerId);
  }, []);

  // --- Public Layout Component (Header + Footer) ---
  const PublicLayout = () => (
    <>
      <Header onRegistrationClick={handleRegistrationOpen} />
      <Outlet />
      <Footer />
    </>
  );

  return (
    <AuthProvider>
      <div className="App">
        <Routes>
          <Route path="/ad-enquiry" element={<EnquiryPage />} />
          {/* === GROUP 1: PUBLIC ROUTES (Uses Website Header/Footer) === */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={
                <>
                  <HeroSection />
                  <StatsSection />
                  <TopCoursesSection />
                  <Tranning />
                  <TrainingBanner />
                  <WhyChooseUs />
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-30 mb-20">
                    <ContactBanner />
                  </div>
                </>
              } 
            />
            
            <Route path="/oauth-callback" element={<OAuthCallback />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/certificate" element={<CertificateVerification />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/guide" element={<GuidancePage />} />
            <Route path="/contact" element={<ContactPage />} />
           
            <Route 
             path="/chat-ai" 
             element={
               <AIChatExpert 
                 onOpenRegister={() => setShowRegistrationModal(true)}
                 onOpenLogin={() => setShowLoginModal(true)} // Now works
               />
             } 
           />
            <Route path="/success" element={<SuccessStoriesPage />} />
            <Route path="/resources/notes" element={<NotesPage />} />
            <Route path="/resources/videos" element={<VideoGallery />} />
            <Route path="/resources/interview" element={<InterviewQuestionsPage />} />

            {/* Course Routes */}
            {/* WEB DEV */}
            <Route path="/java-full-stack" element={<JavaFullStackRedBlack/>} />
            <Route path="/python-full-stack" element={<PythonFullStack />} />
            <Route path="/mern-full-stack" element={<MERNFullStack />} />
            <Route path="/backend-developer" element={<BackendDeveloper />} />
            <Route path="/frontend-developer" element={<FrontendDeveloper />} />
            <Route path="/react-js" element={<ReactJSDeveloper />} />
            <Route path="/angular" element={<AngularFullStack />} />
            <Route path="/wordpress" element={<WordPressDev />} />

            {/* APP DEV */}
            <Route path="/android" element={<AndroidDev />} />
            <Route path="/ios" element={<IOSDevelopment  />} />
            <Route path="/flutter" element={<FlutterDev  />} />
            <Route path="/react-native" element={<ReactNativeDev />} />

            {/* PROGRAMMING */}
            <Route path="/programming/c" element={<CLanguage />} />
            <Route path="/programming/cpp" element={<CppLanguage />} />
            <Route path="/programming/core-java" element={<CoreJava />} />
            <Route path="/programming/advance-java" element={<AdvancedJava />} />
            <Route path="/programming/python" element={<CorePython />} />
            <Route path="/programming/advance-python" element={<AdvancePython />} />
            <Route path="/programming/dsa" element={<DSA />} />
            <Route path="/programming/js-ts" element={<JavaScriptTypeScript />} />
            <Route path="/programming/springboot" element={<SpringBootDev />} />

            {/* SOFTWARE TESTING */}
            <Route path="/software-eng/testing" element={<ManualTesting />} />
            <Route path="software-eng/selenium" element={<AutomationTesting />} />
            <Route path="/software-eng/fullstack" element={<PerformanceTesting />} />
            <Route path="/software-eng/mobile-app" element={<MobileTesting />} />
            <Route path="/api-testing" element={<APITesting />} />

            {/* DATABASES */}
            <Route path="/database/sql" element={<SQLCourse />} />
            <Route path="/database/mysql" element={<MySQLCourse />} />
            <Route path="/database/mongodb" element={<MongoDBCourse />} />
            <Route path="/database/postgresql" element={<PostgreSQL />} />
            <Route path="/database/oracle" element={<OracleCourse />} />

            {/* CLOUD & DEVOPS */}
            <Route path="/cloud-devops/aws" element={<AWSCourse />} />
            <Route path="/cloud-devops/azure" element={<AzureCourse />} />
            <Route path="/cloud-devops/gcp" element={<GCPCourse />} />
            <Route path="/cloud-devops/docker-kubernetes" element={<DockerKubernetes />} />
            <Route path="/cloud-devops/linux" element={<LinuxAdmin />} />
            <Route path="/cloud-devops/cloud-security" element={<CyberSecurity />} />
            <Route path="/grow/with-web" element = {<WithWeb />} />
            <Route path="/grow/with-app" element = {<WithApp />} />

            <Route path="/blogs" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
          </Route>

 

          {/* === GROUP 2: ADMIN LOGIN (Clean, No Header) === */}
          <Route path="/pit-control" element={<AdminLogin />} />


          {/* === GROUP 3: ADMIN PANEL (Uses Admin Layout) === */}
          <Route path="/admin" element={<AdminLayout />}>
             {/* Automatically maps to /admin/dashboard */}
             <Route path="dashboard" element={<AdminDashboard />} />
             <Route path="students" element={<StudentList />} />
             <Route path="students/add" element={<AddStudent />} />
             <Route path="students/edit/:id" element={<EditStudent />} />
             <Route path="queries" element={<QueryList />} />
             <Route path="syllabus" element={<SyllabusPage />} />
             <Route path="notes" element={<AdminNotes />} />
             <Route path="interview-files" element={<AdminInterview />} />
             <Route path="certificate" element={<CertificatePage />} />
             <Route path="quotation/request" element={<QuotationRequests />} />
             <Route path="quotation/create-quote" element={<CreateQuotation />} />
             <Route path="quotation/history" element={<QuotationHistory />} />
             <Route path="ad-enquiry" element={<AdminAdEnquiries />} />
             <Route path="invoice/create" element={<CreateInvoice />} />
             <Route path="invoice/history" element={<InvoiceHistory />} />

             <Route path="/admin/ai-blog" element={<AdminAiBlog />} />
             <Route path="/admin/manage-blogs" element={<ManageBlogs />} />
             {/* Example for future: <Route path="students" element={<StudentList />} /> */}
          </Route>

        </Routes>

        {/* Global Registration Modal */}
        {showLoginModal && (
            <LoginPopup 
                onClose={() => setShowLoginModal(false)}
                onLoginSuccess={() => setShowLoginModal(false)}
            />
        )}
        <RegistrationModal
          isOpen={showRegistrationModal}
          onClose={handleRegistrationClose}
        />
      </div>
    </AuthProvider>
  );
}

export default App;